import { render, staticRenderFns } from "./PDIndex.vue?vue&type=template&id=cc654b94"
import script from "./PDIndex.vue?vue&type=script&lang=js"
export * from "./PDIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports